<template>
  <div id="contenedor-main-listado-presupuestos">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :ejercicio="ejercicio"></desktop>
    </template>
    <template v-else>
      <mobile :ejercicio="ejercicio"></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoPresupuestos',
  components: {
    Desktop,
    Mobile,
  },
  props: {
    ejercicio: Number,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss"></style>
